/* eslint-disable @typescript-eslint/no-explicit-any */
import { GraphQLScalarType } from 'graphql';
import { Kind } from 'graphql/language';

export const DateType = new GraphQLScalarType({
  name: 'Date',
  description: 'Custom scalar type for Date',
  parseValue(value: any) {
    // Parse the incoming value as a date
    return new Date(value);
  },
  serialize(value: any) {
    // Handle null or undefined
    if (value == null) {
      return null;
    }

    // If it's already a Date object, use it directly
    if (value instanceof Date) {
      return value.toISOString();
    }

    // If it's a string, convert it to a Date first
    if (typeof value === 'string') {
      const date = new Date(value);
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return null;
      }
      return date.toISOString();
    }

    // For any other type, try to convert it
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return null;
    }
    return date.toISOString();
  },
  parseLiteral(ast) {
    if (ast.kind === Kind.STRING) {
      // Parse the string literal as a date
      return new Date(ast.value);
    }
    return null; // Invalid input, return null
  }
});
